import { createReducer } from '@reduxjs/toolkit';
import { types } from '../types';

const initialState = {
  setBreadcrumbList: [],
  assetCache: {},
  deviceCache: {},
  assetNameList: [],
  assetId: '',
  asset: {},
  checkObject: [],
  breadcrumbList:[],
  currentSite: '',
  currentLanguage: '',
  currentAssetType: null,
  currentAsset: {}
};


const AssetReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(types.ASSET_CACHE_SUCCESS, (state, action) => {
      state.assetCache = action.response;
    })
    .addCase(types.DEVICE_CACHE_SUCCESS, (state, action) => {
      state.deviceCache = action.response;
    })
    .addCase(types.ASSET_DEVICE_LIST, (state, action) => {
      state.assetNameList = action.assetNameList;
      state.assetId = action.assetId;
      state.asset = action.asset;
      state.siteDirection = action.siteDirection;
      state.checkObject = action.checkObject;
    })
    .addCase(types.Current_ASSET, (state, action) => {
      state.currentAsset = action.asset;
    })
    .addCase(types.SET_BREADCRUMB_LIST, (state, action) => {
      let oldBreadcrumbList = state.breadcrumbList;
      let newObj=[];
            if (Array.isArray(oldBreadcrumbList)) {
              newObj = oldBreadcrumbList;
              newObj.push(action.asset);
            } else {
              newObj = [action.breadCrumbList];
            }
            state.breadcrumbList=newObj;
    })
    .addCase(types.BREADCRUMB_LIST, (state, action) => {
      state.breadcrumbList = action.breadCrumbList;
    })
    .addDefaultCase(() => { });
});

// const AssestReducer = (state = initialState, action) => {
//   let newObj = [];
//   switch (action.type) {
//     case types.ASSET_CACHE_SUCCESS: {
//       return state.set('assetCache', action.response);
//     }
//     case types.DEVICE_CACHE_SUCCESS: {
//       return state.set('deviceCache', action.response);
//     }
//     case types.ASSET_DEVICE_LIST: {
//       return state
//         .set('assetNameList', action.assetNameList)
//         .set('assetId', action.assetId)
//         .set('asset', action.asset)
//         .set('siteDirection', action.siteDirection)
//         .set('checkObject', action.checkObject);
//     }
//     case types.Current_ASSET: {
//       return state.set('currentAsset', action.asset);
//     }
//     case types.SET_BREADCRUMB_LIST: {
//       let oldBreadcrumbList = state.get('breadcrumbList');
//       if (Array.isArray(oldBreadcrumbList)) {
//         newObj = oldBreadcrumbList;
//         newObj.push(action.breadCrumbList);
//       } else {
//         newObj = [action.breadCrumbList];
//       }
//       return state.set('breadcrumbList', newObj);
//     }
//     case types.BREADCRUMB_LIST: {
//       return state.set('breadcrumbList', action.breadcrumbList);
//     }
//     default:
//       return state;
//   }
// };

export default AssetReducer;
